import { Dimensions, StyleSheet } from 'react-native'
import theme from '../../../theme'

const { width } = Dimensions.get('window')

const Styles = StyleSheet.create({
    container: {
        backgroundColor: 'white',
        width: 135,
    },
    containerList: {},
    overlay: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: 'rgba(249, 246, 246, 0.71)', // Gris semi-transparente
        zIndex: 1,
    },
    block_content: {
        backgroundColor: 'white',
    },
    itemCourse: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'space-between',
        marginLeft: 10,
    },
    containerCloudCheck: {
        width: 32,
        height: 32,
        borderRadius: 16,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        top: 6,
        right: 10,
        zIndex: 2,
    },
    imageCourse: {
        aspectRatio: 1,
        borderRadius: 12,
        marginBottom: 5,
    },
    containerItemList: {
        flexDirection: 'row',
        marginBottom: 12,
    },
    imageCourseList: {
        aspectRatio: 1,
        borderRadius: 5,
        marginRight: 8,
        width: 90,
        height: 90,
    },
    blockDataCourse: {
        flex: 1,
        // alignItems: 'top',
    },
    blockDataCourseList: {
        justifyContent: 'center',
    },
    titleCourse: {
        fontSize: 15,
        fontWeight: 'bold',
        marginTop: 4,
        marginBottom: 2,
        color: theme.colors.textPrimary,
    },
    descriptionCourse: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        flex: 1,
    },
    statusModuleList: {
        justifyContent: 'center',
        alignContent: 'center',
        marginTop: 4,
        paddingLeft: 5,
        paddingRight: 8,
        paddingVertical: 3,
        borderRadius: 5,
        borderWidth: 2,
        alignSelf: 'flex-start',
    },
    statusModuleText: {
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: 'center',
        color: 'white',
    },
    spacer: {
        height: 4,
    },
    spacer1: {
        height: 12,
    },
})

export default Styles
